export const linkedInConsent = `
<div>
  Wenn Sie X, Facebook, Instagram, YouTube, LinkedIn oder die dazugehörigen Dienste nutzen, werden <a href="#warn_yellowLinkedIn">Ihre personenbezogene Daten</a> sowie Ihr Nutzerverhalten und Lesedaten von den Betreibern dieser Plattformen zur <a href="#warn_greenLinkedIn">Profilbildung</a> (u.a. Personalisierung für eigene Produkte und Werbung Dritter) gesammelt. Ihre Daten werden mit Ihren Netzwerkkontakten, aber auch mit Dritten <a href="#warn_blueLinkedIn">geteilt</a>. Sie werden außerdem in die USA, die kein gleichwertiges Schutzniveau Ihrer Daten zu Deutschland bieten, <a href="#warn_darkLinkedIn">übermittelt</a> und dort für geschäftliche Zwecke (z. B. personalisierte Werbung) wie beschrieben gespeichert, verarbeitet und an Dritte weitergegeben. Die öffentlichen Stellen (also Gemeinden, Behörden, Gerichte, Regierungsstellen, etc.), die einen LinkedIn-, YouTube-,Facebook- oder Instagram-Auftritt haben, sind für die hier beschriebene Datensammlung insofern mitverantwortlich, als dass sie den genannten Netzwerken die Datensammlung erst ermöglichen, u.a. durch das Setzen von Cookies.
</div>

<h1 class="warn_h1" id="warn_yellowLinkedIn">Welche personenbezogene Daten sammelt LinkedIn?</h1>

<h2 class="warn_h2">LinkedIn sammelt verschiedene personenbezogene Daten, die Sie und andere mitteilen. Dazu gehören folgende Daten:</h2>

<dl class="warn_section_list">
  <dt class="warn_section_item">Profilinformationen</dt>
  <dd class="warn_section_desc">Ihr Name, Ihre beruflichen Erfahrungen, Ausbildung, Fähigkeiten, Empfehlungen und andere Informationen, die Sie in Ihrem Profil teilen.</dd>

  <dt class="warn_section_item">Netzwerkaktivitäten</dt>
  <dd class="warn_section_desc">Ihre Kommentare, „Gefällt mir“-Markierungen, und Ihre Aktivitäten in Gruppen sowie Ihre „Folgen“-Funktion.</dd>

  <dt class="warn_section_item">Privatsphäre-Einstellungen</dt>
  <dd class="warn_section_desc">Einstellungen, die Sie treffen, um zu bestimmen, wer Ihre Daten sehen kann und ob Ihre Inhalte für interessenbezogene Werbung ausgewertet werden sollen.</dd>
</dl>

<h2 class="warn_h2">Zusätzliche personenbezogene Daten, die LinkedIn über Sie sammelt</h2>

<dl class="warn_section_list">
  <dt class="warn_section_item">Daten, die nicht über Einstellungen beeinflusst werden können</dt>
  <dd class="warn_section_desc">LinkedIn teilt Daten für die Entwicklung und Bereitstellung der Dienste mit Partnerunternehmen und externen Dienstleistern, dies lässt sich nicht über die Privatsphäre-Einstellungen beeinflussen.</dd>
</dl>

<h2 class="warn_h2">Zusätzliche personenbezogene Daten, die LinkedIn über Sie sammelt</h2>

<dl class="warn_section_list">
  <dt class="warn_section_item">Daten, die nicht über Einstellungen beeinflusst werden können</dt>
  <dd class="warn_section_desc">LinkedIn teilt Daten für die Entwicklung und Bereitstellung der Dienste mit Partnerunternehmen und externen Dienstleistern, dies lässt sich nicht über die Privatsphäre-Einstellungen beeinflussen.</dd>
</dl>

<h2 class="warn_h2">Personenbezogene Daten, die LinkedIn teilt und offenlegt</h2>

<dl class="warn_section_list">
  <dt class="warn_section_item">Datennutzung zur Verbesserung der Dienste</dt>
  <dd class="warn_section_desc">Ihre Daten werden für die Bereitstellung und Verbesserung von LinkedIn-Diensten genutzt, auch durch die Analyse mit KI.</dd>
</dl>
`;
